import { BCRadioButtonGroup, IComboboxSelectedChangeEventArgs } from '@bimser/components';
import { FormItemTypes, IDictionary, IItem, isNullOrUndefined } from '@bimser/core';
import { Map } from 'immutable';
import { JSX } from 'react';
import { Direction, IPropertyField, RadioListButtonType } from '../../../../entities/common';
import ComboBoxBase from '../../base/ComboBoxBase';
import { filterFields } from '../../helper';
import Styles from './assets/styles.scss';
import { IRadioListProperties } from './entities/IRadioListProperties';

export default class RadioList extends ComboBoxBase {
	buttonType: RadioListButtonType;
	direction: Direction;
	showSearch: boolean;

	constructor() {
		super();

		this.triggerValueChanged = this.triggerValueChanged.bind(this);

		this.controlType = FormItemTypes.EControlTypes.RadioList;
		this.direction = 'vertical';
		this.buttonType = 'radio';
		this.showSearch = false;
		this.items = [];

		this.subscribe('trigger:OnValueChanged', (data: string) => {
			const item = this.items.find(i => i.key === data);
			this.triggerValueChanged({ data: item?.value, senderArgs: undefined });
		});
	}

	__loadProperties(data: IRadioListProperties) {
		super.__loadProperties(data);

		this.__proxyChanged.direction = data.direction;
		this.__proxyChanged.buttonType = data.buttonType;
		this.__proxyChanged.showSearch = data.showSearch;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			buttonType: this.buttonType,
			direction: this.direction,
			showSearch: this.showSearch,
			options: this.__getItems()
		};
	}

	__getPropertyFields(properties?: Map<string, any>): IPropertyField[] {
		return [
			...filterFields(super.__getPropertyFields(properties), ['allowClear', 'placeholder']),
			{
				name: 'direction',
				type: 'enum',
				enumMembers: ['horizontal', 'vertical'] as Direction[]
			},
			{
				name: 'showSearch',
				type: 'boolean'
			}
		];
	}

	private triggerValueChanged(args: IComboboxSelectedChangeEventArgs<string>) {
		if (
			!isNullOrUndefined(args.data) &&
			args.data.toString() != '' &&
			this.items.some(_item => _item.value === args.data)
		) {
			this.__proxyChanging.selectedItemValues = [args.data];
			this.__proxyChanging.items = this.items.map(item => ({
				...item,
				selected: item.value === args.data
			}));
		} else {
			this.__proxyChanging.selectedItemValues = [];
			this.__proxyChanging.items = this.items.map(item => ({ ...item, selected: false }));
		}
	}

	__getItems(): IItem[] {
		const items = Object.values(this.__itemsCollection).map(i => ({
			key: i.key,
			value: i.value,
			selected: this.selectedItemValues?.includes(i.value),
			text: i.text.getText()
		}));

		return this.__sortItems(items);
	}

	__render() {
		return super.__render(
			<BCRadioButtonGroup
				style={{ backgroundColor: this.style.backgroundColor }}
				disabled={this.loading || this.__isDisabled()}
				onChange={this.triggerValueChanged}
				containerClassName={Styles.containerStyles}
				readOnly={this.__isReadOnly()}
				showSearch={this.showSearch}
				buttonType={this.buttonType}
				options={this.__getItems()}
				onSearch={this.__onSearch}
				mode={this.direction}
				value={this.value}
			/>
		);
	}
}
